import React from 'react';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Slide from '@material-ui/core/Slide';
import SchoolIcon from '@material-ui/icons/School';
import {makeStyles} from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';


const useStyles = makeStyles(theme => ({
    paperEd: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      border: '2px solid #000',
      width: `666px`,
      overflow: 'auto'
    },
    modalEd: {
      display: 'flex',
      alignItems: 'right',
      justifyContent: 'right',
      flexDirection:"row-reverse"
    },


}));

export default function EdModal({TextRu, TextEng}) {
  const [openEd, setOpenEd] = React.useState(false);
  const [language, setLanguage] = React.useState('Eng');
  const classes = useStyles();

  const chooseLang = (name) => {
    setLanguage(name)
  }

  return (
    <>
    <Button
      onClick={() => setOpenEd(true)}>
      <SchoolIcon style={{color: '#45adf7'}} />
    </Button>


    <Modal
        aria-labelledby="update-modal-title"
        aria-describedby="update-modal-description"
        className={classes.modalEd}
        open={openEd}
        onClose={() => setOpenEd(false)}
    >
      <Slide direction="left" in={openEd} mountOnEnter unmountOnExit>
        <div className={classes.paperEd}>
            <Chip
              label='Ru'
              onClick={() => chooseLang('Ru')}
              style={{marginRight: '10px'}}/>
            <Chip
              label='Eng'
              onClick={() => chooseLang('Eng')}
              style={{marginRight: '10px'}}/>
            {
              language === 'Eng' ?
              <TextEng/> : <TextRu/>
            }
        </div>
      </Slide>
    </Modal>

    </>
  )
}
